(() => {
  if (window.__pdpAnalyticsLoaded) return;
  window.__pdpAnalyticsLoaded = true;

  const PUBLISH_RETRIES = 20;
  const TREATMENT_VERSION = 'pdp-sticky-atc-v1.0.0';
  const THEME_BUILD_HASH = 'f4bf43e48540f23ff198a7465a67631b54e3dfb4ed00c0b04a4354016ce12fac';
  const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
  if (!productInfo) return;

  const sectionId = productInfo.dataset.section;
  const productForm = productInfo.querySelector(`#product-form-${sectionId}`);
  const productFormElement = productForm?.closest('product-form');
  const mainSubmit = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
  const primaryPicker = productInfo.querySelector('variant-selects[data-primary]');
  let pendingAtc = null;
  let pendingOption = null;
  let lastVariantKey = null;
  let stickyImpressionSent = false;
  let lastDynamicCheckoutAt = 0;

  const getVariantId = () => productForm?.querySelector('input[name="id"]')?.value || '';
  const isAvailable = () => Boolean(getVariantId()) && !mainSubmit?.disabled && mainSubmit?.getAttribute('aria-disabled') !== 'true';
  const device = () => (window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop');
  const experiments = () => {
    const value = window.PdpExperiments?.getContext?.() || window.__pdpExperiments?.context || {};
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (_) {
      return {};
    }
  };
  const common = () => ({
    product_id: productInfo.dataset.productId || '',
    product_handle: productInfo.dataset.productHandle || '',
    variant_id: getVariantId(),
    template: productInfo.dataset.productTemplate || 'product',
    market: productInfo.dataset.productMarket || '',
    country: productInfo.dataset.productCountry || '',
    device: device(),
    experiments: experiments(),
    treatment_version: TREATMENT_VERSION,
    theme_build_hash: THEME_BUILD_HASH,
    theme_version: window.theme?.settings?.themeVersion || '',
  });

  const publish = (name, detail = {}, attempt = 0) => new Promise((resolve) => {
    if (window.Shopify?.analytics?.publish) {
      try {
        const result = window.Shopify.analytics.publish(name, { ...common(), ...detail });
        if (result?.then) {
          result.then(() => resolve(true)).catch(() => resolve(false));
        } else {
          resolve(true);
        }
      } catch (_) {
        resolve(false);
      }
      return;
    }
    if (attempt < PUBLISH_RETRIES) {
      window.setTimeout(() => publish(name, detail, attempt + 1).then(resolve), 250);
    } else {
      resolve(false);
    }
  });

  window.PdpAnalytics = Object.freeze({
    publish,
    getCommon: common,
  });

  const setPendingAtc = (placement) => {
    pendingAtc = {
      placement,
      variantId: getVariantId(),
      expiresAt: Date.now() + 20000,
    };
    publish('atc_click', { placement });
  };

  const takePendingAtc = (event, outcome) => {
    if (!pendingAtc || pendingAtc.expiresAt < Date.now()) {
      pendingAtc = null;
      return;
    }
    if (event?.source && event.source !== 'product-form') return;
    const eventVariantId = String(event?.productVariantId || '');
    if (pendingAtc.variantId && eventVariantId && pendingAtc.variantId !== eventVariantId) return;
    publish(outcome, {
      placement: pendingAtc.placement,
      variant_id: eventVariantId || pendingAtc.variantId,
      error_type: outcome === 'atc_error' ? 'cart_error' : '',
    });
    pendingAtc = null;
  };

  const describeOption = (target) => {
    if (!target?.matches?.('input[name^="options["], select[name^="options["]')) return null;
    const rawName = target.name || '';
    const optionName = rawName.replace(/^options\[/, '').replace(/\]$/, '');
    let optionValue = target.value || '';
    if (target.type === 'radio') {
      optionValue = primaryPicker?.querySelector(`input[name="${CSS.escape(rawName)}"]:checked`)?.value || optionValue;
    }
    return { option_name: optionName, option_value: optionValue, option: `${optionName}=${optionValue}` };
  };

  const publishVariant = (variant, source = 'main') => {
    const detail = {
      ...(pendingOption || {}),
      variant_id: variant?.id ? String(variant.id) : getVariantId(),
      available: variant ? variant.available === true : isAvailable(),
      source,
    };
    const key = [detail.option, detail.variant_id, detail.available, detail.source].join('|');
    if (key === lastVariantKey) return;
    lastVariantKey = key;
    publish('variant_change', detail);
    pendingOption = null;
  };

  const publishDynamicCheckout = () => {
    if (Date.now() - lastDynamicCheckoutAt < 1500) return;
    lastDynamicCheckoutAt = Date.now();
    publish('dynamic_checkout_click', { placement: 'pdp_main' });
  };

  mainSubmit?.addEventListener('click', () => setPendingAtc('pdp_main'));
  document.addEventListener('pdp:atc-click', (event) => {
    if (event.detail?.productInfo === productInfo || event.detail?.sectionId === sectionId) {
      setPendingAtc('pdp_sticky');
    }
  });
  document.addEventListener('pdp:sticky-visibility', (event) => {
    if (!stickyImpressionSent && event.detail?.visible && event.detail?.sectionId === sectionId) {
      stickyImpressionSent = true;
      publish('pdp_sticky_impression', { placement: 'pdp_sticky' });
    }
  });
  document.addEventListener('pdp:size-guide', (event) => {
    const detail = event.detail || {};
    if (detail.sectionId && detail.sectionId !== sectionId) return;
    if (!['size_guide_target_missing', 'size_guide_open'].includes(detail.name)) return;
    publish(detail.name, { placement: 'pdp_variant_picker' });
  });

  primaryPicker?.addEventListener('change', (event) => {
    pendingOption = describeOption(event.target);
  });

  productForm?.querySelector('input[name="id"]')?.addEventListener('change', () => {
    window.setTimeout(() => publishVariant(null, 'main'), 0);
  });

  productFormElement?.addEventListener('pointerdown', (event) => {
    if (event.target.closest('.shopify-payment-button')) publishDynamicCheckout();
  });
  window.addEventListener('blur', () => {
    window.setTimeout(() => {
      if (document.activeElement?.closest?.('.shopify-payment-button')) publishDynamicCheckout();
    }, 0);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    if (PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => takePendingAtc(event, 'atc_success'));
    }
    if (PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, (event) => takePendingAtc(event, 'atc_error'));
    }
    if (PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data?.sectionId || data.sectionId === sectionId) publishVariant(data?.variant, 'main');
      });
    }
  }
})();
